import { Fragment, jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { useEffect } from "react";
import utils_mask from "@vk-hr-tek/ui/ReactInputMask/utils/mask";
const Autorecognition = (t0)=>{
    const $ = c(17);
    const { children, recognizedValue, isRecognitionUsedBefore, onBlur, disabled, value, setValue, mask } = t0;
    let t1;
    let t2;
    if ($[0] !== mask || $[1] !== recognizedValue || $[2] !== setValue || $[3] !== value) {
        t1 = ()=>{
            if (recognizedValue && !value) if (mask) {
                const inputMask = new utils_mask({
                    mask,
                    maskPlaceholder: "_"
                });
                const newValue = inputMask.formatValue(recognizedValue);
                setValue(newValue);
            } else setValue(recognizedValue);
        };
        t2 = [
            setValue,
            recognizedValue,
            value,
            mask
        ];
        $[0] = mask;
        $[1] = recognizedValue;
        $[2] = setValue;
        $[3] = value;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    useEffect(t1, t2);
    let t3;
    if ($[6] !== disabled || $[7] !== isRecognitionUsedBefore || $[8] !== onBlur || $[9] !== recognizedValue) {
        t3 = ()=>{
            if (isRecognitionUsedBefore && !disabled && !recognizedValue) onBlur();
        };
        $[6] = disabled;
        $[7] = isRecognitionUsedBefore;
        $[8] = onBlur;
        $[9] = recognizedValue;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== disabled || $[12] !== isRecognitionUsedBefore || $[13] !== onBlur) {
        t4 = [
            isRecognitionUsedBefore,
            disabled,
            onBlur
        ];
        $[11] = disabled;
        $[12] = isRecognitionUsedBefore;
        $[13] = onBlur;
        $[14] = t4;
    } else t4 = $[14];
    useEffect(t3, t4);
    let t5;
    if ($[15] !== children) {
        t5 = /*#__PURE__*/ jsx(Fragment, {
            children: children
        });
        $[15] = children;
        $[16] = t5;
    } else t5 = $[16];
    return t5;
};
export { Autorecognition };
